<template>
  <b-overlay
    :show="!is_ready('checkout_calculations')"
    :rounded="false"
    :spinner-small="true"
    bg-color="white"
  >
    <div class="basket-totals">
      <div class="total">
        Subtotal:
        <span class="total-value">{{ basket.totals.subtotal | currency }}</span>
      </div>
      <div v-if="!noDelivery" class="total">
        Delivery:
        <span class="total-value">{{ basket.totals.shipping | currency }}</span>
      </div>
      <div class="total" v-if="basket.totals.discount !== 0">
        Discount:
        <span class="total-value">{{ basket.totals.discount | currency }}</span>
      </div>
      <div class="total">
        Tax:
        <span class="total-value">{{
          !noDelivery
            ? basket.totals.tax
            : basket.totals.tax_exshipping | currency
        }}</span>
      </div>
      <div
        class="total"
        v-if="basket.totals.rangefrom && basket.totals.rangeto && basket.totals.rangefrom !== basket.totals.rangeto"
      >
        Pay Upon Confirmation:
        <span class="total-value"
          >{{ basket.totals.rangefrom | currency }} -
          {{ basket.totals.rangeto | currency }}</span
        >
      </div>
      <div
        class="total"
        v-if="basket.totals.rangefrom && basket.totals.rangeto && basket.totals.rangefrom === basket.totals.rangeto"
      >
        Pay Upon Confirmation:
        <span class="total-value"
          >{{ basket.totals.rangeto | currency }}</span
        >
      </div>
      <div class="total grand-total">
        Total:
        <span class="total-value">{{
          !noDelivery
            ? basket.totals.total
            : basket.totals.total_exshipping | currency
        }}</span>
      </div>
    </div>
  </b-overlay>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  props: {
    noDelivery: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {};
  },
  components: {},
  computed: {
    ...mapGetters("readiness", ["is_ready"]),
    basket() {
      return this.$store.state.basket;
    },
  },
};
</script>